// RetroVideoPlayer.jsx
import { useState, useRef, useEffect } from 'react';

function RetroVideoPlayer({ src }) {
    const videoRef = useRef(null);
    const [playing, setPlaying] = useState(false);
    const [progress, setProgress] = useState(0);
    const [duration, setDuration] = useState(0);
    const [volume, setVolume] = useState(1);
    const [muted, setMuted] = useState(false);

    useEffect(() => {
        const v = videoRef.current;
        if (!v) return;
        const onTime = () => setProgress(v.currentTime);
        const onLoaded = () => setDuration(v.duration);
        const onEnd = () => setPlaying(false);
        v.addEventListener('timeupdate', onTime);
        v.addEventListener('loadedmetadata', onLoaded);
        v.addEventListener('ended', onEnd);
        return () => {
            v.removeEventListener('timeupdate', onTime);
            v.removeEventListener('loadedmetadata', onLoaded);
            v.removeEventListener('ended', onEnd);
        };
    }, [src]);

    const togglePlay = () => {
        const v = videoRef.current;
        if (playing) v.pause();
        else v.play();
        setPlaying(!playing);
    };

    const handleSeek = (e) => {
        const v = videoRef.current;
        const rect = e.currentTarget.getBoundingClientRect();
        const pct = (e.clientX - rect.left) / rect.width;
        v.currentTime = pct * duration;
    };

    const handleVolume = (e) => {
        const v = videoRef.current;
        const rect = e.currentTarget.getBoundingClientRect();
        const pct = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width));
        v.volume = pct;
        setVolume(pct);
        setMuted(pct === 0);
    };

    const toggleMute = () => {
        const v = videoRef.current;
        v.muted = !muted;
        setMuted(!muted);
    };

    const formatTime = (t) => {
        if (!t || isNaN(t)) return '0:00';
        const m = Math.floor(t / 60);
        const s = Math.floor(t % 60).toString().padStart(2, '0');
        return `${m}:${s}`;
    };

    const btnStyle = {
        background: '#c0c0c0',
        border: '2px solid #fff',
        borderRight: '2px solid #8a8680',
        borderBottom: '2px solid #8a8680',
        width: '26px', height: '22px',
        cursor: 'pointer',
        fontSize: '11px',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontFamily: "'MS Sans Serif', 'Tahoma', Arial, sans-serif",
    };

    return (
        <div style={{ background: '#c0c0c0', padding: '4px', fontFamily: "'MS Sans Serif', 'Tahoma', Arial, sans-serif" }}>
            <div style={{ background: '#000', position: 'relative' }}>
                <video ref={videoRef} src={src} style={{ width: '100%', display: 'block' }} onClick={togglePlay} />
            </div>

            {/* Barre de progression style rétro */}
            <div
                onClick={handleSeek}
                style={{
                    height: '14px', background: '#fff',
                    border: '2px solid #8a8680', borderTop: '2px solid #404040', borderLeft: '2px solid #404040',
                    margin: '4px 0', cursor: 'pointer', position: 'relative',
                }}
            >
                <div style={{
                    height: '100%',
                    width: `${duration ? (progress / duration) * 100 : 0}%`,
                    background: '#000080',
                }} />
            </div>

            {/* Contrôles */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                <button onClick={togglePlay} style={btnStyle}>{playing ? '❚❚' : '▶'}</button>
                <button onClick={() => { videoRef.current.pause(); videoRef.current.currentTime = 0; setPlaying(false); }} style={btnStyle}>■</button>
                <button onClick={toggleMute} style={btnStyle}>{muted || volume === 0 ? '🔇' : '🔊'}</button>

                <div
                    onClick={handleVolume}
                    style={{
                        width: '60px', height: '10px', background: '#fff',
                        border: '1px solid #8a8680', borderTop: '1px solid #404040', borderLeft: '1px solid #404040',
                        cursor: 'pointer', position: 'relative',
                    }}
                >
                    <div style={{ height: '100%', width: `${(muted ? 0 : volume) * 100}%`, background: '#000080' }} />
                </div>

                <span style={{ fontSize: '10px', color: '#000', marginLeft: 'auto' }}>
                    {formatTime(progress)} / {formatTime(duration)}
                </span>
            </div>
        </div>
    );
}

export default RetroVideoPlayer;